/** @file Assets key bindings (context `assets`, live while focus is inside the panel). */
import type { Binding } from '@pose2d/shortcuts/types';

/** Delete asks to delete the focused image or attachment. */
export const bindings: Binding[] = [{ id: 'assets.delete', keys: 'Delete', context: 'assets' }];
